export const showMemberActivityFeature =
    process.env.REACT_APP_CF_PAGES === '1' && process.env.REACT_APP_CF_PAGES_BRANCH === 'dev-02';

// HWM-22792: the Demographics "Set by member on device" name/DOB box is hidden until the backend
// fixes the device values it returns. Flip back to true once that ships.
export const showDeviceValuesOnDemographics = false;
